import { render, staticRenderFns } from "./ReplacementDetails.vue?vue&type=template&id=c469d56c&scoped=true"
import script from "./ReplacementDetails.vue?vue&type=script&lang=ts"
export * from "./ReplacementDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c469d56c",
  null
  
)

export default component.exports